module.exports = __webpack_public_path__ + "img/notificaciones.ad3db499.svg";